module.exports = __webpack_public_path__ + "img/child-channel-bg.b89bf98e.png";